import { BASE_URL } from '@/constants';
import { createContext, useState, useEffect, useCallback, useRef } from 'react';
import { io } from 'socket.io-client';

export const SocketContext = createContext<any>(null);

export const SocketProvider = ({ children }: any) => {
	const [socket, setSocket] = useState<any>(null);
	const socketRef = useRef<any>(null);
	const connectingRef = useRef(false);

	const onConnect = useCallback(() => {
		connectingRef.current = false;
		setSocket(socketRef.current);
	}, []);

	const onDisconnect = useCallback(() => {
		setSocket(null);
	}, []);

	useEffect(() => {
		if (!socket && !connectingRef.current) {
			connectingRef.current = true;

			const websocket = io(BASE_URL, {
				transports: ['websocket', 'polling'],
			});

			if (!websocket.hasListeners('connect')) {
				websocket.on('connect', onConnect);
			}

			if (!websocket.hasListeners('disconnect')) {
				websocket.on('disconnect', onDisconnect);
			}

			socketRef.current = websocket;
		}

		return () => {
			if (socket) {
				if (socket.hasListeners('connect')) {
					socket.off('connect', onConnect);
				}

				if (socket.hasListeners('disconnect')) {
					socket.off('disconnect', onDisconnect);
				}

				if (socket.connected) {
					socket.disconnect();
				}
			}
		};
	}, [socket, onConnect, onDisconnect]);

	return <SocketContext.Provider value={socket}>{children}</SocketContext.Provider>;
};
